'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).factory('Dashboard', ['$resource', 'apiSettings', function ($resource, apiSettings) {
	return $resource(null, null, {
		dashboard: {
			url: apiSettings.baseUri + 'v1/dashboard',
			method: 'GET',
			isArray: false
		},
		dashboardCharts: {
			url: apiSettings.baseUri + 'v1/dashboard/charts/promotionrequests',
			method: 'GET',
			isArray: false
		},
		roi: {
			url: apiSettings.baseUri + 'v1/dashboard/promotionrequests/roi',
			method: 'GET',
			isArray: false
		},
		funnel: {
			url: apiSettings.baseUri + 'v1/dashboard/promotionrequests/funnel',
			method: 'GET',
			isArray: false
		},
		approval: {
			url: apiSettings.baseUri + 'v1/dashboard/promotionrequests/approval',
			method: 'GET',
			isArray: false
		},
		sellers: {
			url: apiSettings.baseUri + 'v1/dashboard/promotionrequests/sellers',
			method: 'GET',
			isArray: true
		},
		segmentation: {
			url: apiSettings.baseUri + 'v1/dashboard/promotionrequests/segmentation',
			method: 'GET',
			isArray: false
		}
	});
}]);
